import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { PopOverLocal } from './styled';

//APP
import { GeoPointFeature } from '../..';

//COMPONENTS
import { ModalPopOver } from '../../../../../../../../../../../../../../../../Components/CustomUi/modalPopOver';
import { ConteudoSelecaoEmMassa } from './conteudo';

const LARGURA_POPOVER = 480

interface PropsSelecaoEmMassa {
    open: boolean
    onClose: Function
    /** Retângulo do botão que abriu o popover, para posicioná-lo ancorado. */
    ancora?: DOMRect | null
    isFullscreen?: boolean
    pontos_da_malha: GeoPointFeature[]
    pontos_selecionados_adicionados: any[]
    analises_salvas: any[]
    talhao_area: string
    onConfirmar: (pontos: GeoPointFeature[]) => void
}

/**
 * Popover de seleção em massa.
 *
 * Fora do fullscreen usa o ModalPopOver padrão, posicionado a partir do retângulo do
 * botão. Em fullscreen o ModalPopOver não serve: ele renderiza num portal (#portal)
 * que fica fora do elemento em tela cheia, e o navegador não exibe nada fora dele —
 * então o mesmo conteúdo é montado num container local ancorado ao botão.
 */
export const SelecaoEmMassa: React.FC<PropsSelecaoEmMassa> = ({ open, onClose, ancora, isFullscreen,
    pontos_da_malha, pontos_selecionados_adicionados, analises_salvas, talhao_area, onConfirmar
}) => {

    if (!open) return null

    const conteudo = (
        <ConteudoSelecaoEmMassa
            pontos_da_malha={pontos_da_malha}
            pontos_selecionados_adicionados={pontos_selecionados_adicionados}
            analises_salvas={analises_salvas}
            talhao_area={talhao_area}
            onConfirmar={onConfirmar}
        />
    )

    if (isFullscreen) {
        return (
            <PopOverLocal>
                <div className='popover__local__header'>
                    Seleção em massa
                    <button className='popover__local__fechar' onClick={() => onClose()}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
                <div className='popover__local__body'>{conteudo}</div>
            </PopOverLocal>
        )
    }

    /**
     * O popover sobrepõe o botão: alinhado pela borda esquerda dele e começando no seu topo.
     *
     * O ModalPopOver é fixed e recebe `right` como CSS puro, então convertemos o `left`
     * desejado em distância até a borda direita da janela. O clamp garante que o box não
     * passe de nenhuma das bordas, inclusive em janelas mais estreitas que ele.
     */
    const MARGEM = 14
    const largura = Math.min(LARGURA_POPOVER, window.innerWidth - MARGEM * 2)

    const left_desejado = ancora ? ancora.left : MARGEM
    const left_max = window.innerWidth - largura - MARGEM
    const left = Math.max(MARGEM, Math.min(left_desejado, left_max))
    const right = window.innerWidth - left - largura

    // Sobrepõe a partir do topo do botão, sem deixar o popover sair pela base da tela.
    const altura_estimada = 420
    const top_desejado = ancora ? ancora.top : 100
    const top = Math.max(MARGEM, Math.min(top_desejado, window.innerHeight - altura_estimada))

    return (
        <ModalPopOver
            open={open}
            onClose={onClose}
            title='Seleção em massa'
            width={largura}
            height='fit-content'
            top={top}
            right={right}
        >
            {conteudo}
        </ModalPopOver>
    )
}
